import React from 'react'
import Page from '../Page';
import './privacy.css'

import data from './privacyPolicy.json'

export default class index extends Page {
   constructor(props){
      super(props)
      this.state = {
         data
      }
   }

  render() {
   const {data} = this.state
    return (
      <div className='container-privacy'>
         <div className='center-doc mb-m'>
            <div>
               <h4 className="title-privacy h4-privacy" dangerouslySetInnerHTML={{__html : data.title}} />
               <p className="sub_title p-privacy" dangerouslySetInnerHTML={{__html : data.subTitle}}/>
            </div>
         </div>
         <p className='mb-s p-privacy' dangerouslySetInnerHTML={{__html : data.latestUpdate}}/>
         <p className='mb-m p-privacy' dangerouslySetInnerHTML={{__html : data.warningText}}/>
         <div className='content-style'>
            <ol>
               {
                  data.mainInfo.map((mainItem, mainIndex) => {
                     return(
                     <li key={mainIndex}>
                        <p className='p-privacy' dangerouslySetInnerHTML={{__html : mainItem.infoTitle}}/>
                        {
                           mainItem.infoContent.map((subItem, subIndex) => {
                              return(
                                 <div key={subIndex}>
                                    <p className='p-privacy' dangerouslySetInnerHTML={{__html : subItem.content}}/>
                                    {
                                       subItem.subContent.map((sub_subItem, sub_subIndex) =>{
                                          return(
                                             <div key={sub_subIndex}>
                                                <p className='p-privacy' dangerouslySetInnerHTML={{__html : sub_subItem.subContentTitle}}/>
                                                <ol style={{listStyle: 'lower-alpha'}}>
                                                {
                                                   sub_subItem.subContentList.map((sub2_subItem, sub2_subIndex)=>{
                                                      return(
                                                            <div key={sub2_subIndex}>
                                                               <li dangerouslySetInnerHTML={{__html : sub2_subItem.subContent_content}}/>
                                                               <ol style={{listStyle: 'lower-roman'}}>
                                                                  {
                                                                     sub2_subItem.sub_subContent.map((sub3_subItem, sub3_subIndex)=>{
                                                                        return(
                                                                           <div key={sub3_subIndex}>
                                                                              <li dangerouslySetInnerHTML={{__html : sub3_subItem.sub_subContent_content}}/>
                                                                           </div>
                                                                        )
                                                                     })
                                                                  }
                                                               </ol>
                                                            </div>
                                                      )
                                                   })
                                                }
                                                </ol>
                                             </div>
                                          )
                                       })
                                    }
                                 </div>
                                 
                              )
                           })
                        }
                     </li>
                     )
                  })
               }
            </ol>
         </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy/index.js